const DEV_REPORT_IGNORE_ATTRIBUTE = "data-dev-report-ignore";

/** Marks the reporting UI itself, so it never appears in its own capture. */
export const devReportIgnoreProps = { [DEV_REPORT_IGNORE_ATTRIBUTE]: "true" };

const SCREENSHOT_MIME_TYPE = "image/jpeg";
const SCREENSHOT_QUALITY = 0.8;

const isIgnored = (node: Node): boolean =>
  node instanceof Element && node.hasAttribute(DEV_REPORT_IGNORE_ATTRIBUTE);

/** JPEG keeps a full-page capture well inside the API's 5MB limit. */
const opaqueBackground = (): string => {
  const bodyBackground = window.getComputedStyle(document.body).backgroundColor;
  if (bodyBackground && !bodyBackground.startsWith("rgba(0, 0, 0, 0)")) {
    return bodyBackground;
  }

  return window.getComputedStyle(document.documentElement).backgroundColor;
};

/**
 * Rasterises the page as it currently stands, minus the reporting UI itself.
 */
export const captureScreenshot = async (): Promise<File> => {
  const { domToBlob } = await import("modern-screenshot");

  const blob = await domToBlob(document.body, {
    type: SCREENSHOT_MIME_TYPE,
    quality: SCREENSHOT_QUALITY,
    scale: 1,
    backgroundColor: opaqueBackground(),
    filter: (node) => !isIgnored(node),
  });

  return new File([blob], "screenshot.jpg", { type: SCREENSHOT_MIME_TYPE });
};
